import React, { useEffect, useState } from "react";
import "../styles/exploreTeam.css";
import Card from "./Card";
import firebase from "../firebase";
import { motion } from "framer-motion";

const SubLeads = () => {
  // Member Logic

  const [techLead, setTechLead] = useState({});
  const [managementLead, setManagementLead] = useState({});
  const [loading, setLoading] = useState(false);
  const refMembers = firebase.firestore().collection("members");
  function getTechLead() {
    setLoading(!loading);
    refMembers
      .where("role", "==", "Technical Lead")
      .where("active", "==", true)
      .get()
      .then((querySnapshot) => {
        const items = [];
        querySnapshot.forEach((doc) => items.push(doc.data()));
        setTechLead(items[0]);
      });
    setLoading(!loading);
  }
  function getManagementLead() {
    setLoading(!loading);
    refMembers
      .where("role", "==", "Management Lead")
      .where("active", "==", true)
      .get()
      .then((querySnapshot) => {
        const items = [];
        querySnapshot.forEach((doc) => items.push(doc.data()));
        setManagementLead(items[0]);
      });
    setLoading(!loading);
  }
  useEffect(() => {
    getTechLead();
    getManagementLead();
  }, []);
  let outsideArr = [];
  let insideArr = [];

  return (
    <div
      className="member-cards
      flex-col
      md:flex
      md:flex-row
      items-center
      justify-between
      my-12"
    >
      <div
        className="
          h-screen
          flex
          mb-8
          md:mb-0
          flex-col
          justify-around
          md:justify-center
          items-center
          relative
        "
      >
        <h1
          className="headline
            mb-4
            md:mb-28
            text-5xl
            relative
            dark:text-white
            text-center
          "
        >
          Technical Team Lead
        </h1>
        {1 && (
          <div className="lead-card">
            <Card
              name={techLead.name}
              image={techLead.profileImage}
              skill={techLead.description}
              position={techLead.role}
              classStudying={techLead.department}
              year={techLead.year}
              linkedin={techLead.linkedin ? techLead.linkedin : ""}
              github={techLead.github ? techLead.github : ""}
              facebook={techLead.facebook ? techLead.facebook : ""}
              instagram={techLead.instagram ? techLead.instagram : ""}
            />
          </div>
        )}
      </div>
      <div
        className="
          h-screen
          flex
          mb-8
          md:mb-0
          flex-col
          justify-around
          md:justify-center
          items-center
          relative
        "
      >
        <h1
          className="headline
            mb-4
            md:mb-28
            text-5xl
            relative
            dark:text-white text-center
          "
        >
          Management Team Lead
        </h1>
        {1 && (
          <div className="lead-card">
            <Card
              name={managementLead.name}
              image={managementLead.profileImage}
              skill={managementLead.description}
              position={managementLead.role}
              classStudying={managementLead.department}
              year={managementLead.year}
              linkedin={managementLead.linkedin ? managementLead.linkedin : ""}
              github={managementLead.github ? managementLead.github : ""}
              facebook={managementLead.facebook ? managementLead.facebook : ""}
              instagram={managementLead.instagram ? managementLead.instagram : ""}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default SubLeads;
